/**
 * LyraApiKeyModal — "Manage Lyra API Key" from Settings/Profile, inline.
 * Previously this navigated away to a full MCP Servers management page (an
 * alias route rendering the same component as /mcp-servers) just to let a
 * user generate/copy/revoke their personal key — confusing since that page
 * is really about managing *external* MCP server connections. This reuses
 * the exact same key-management logic (PersonalMcpPanel, unchanged) in an
 * `embedded` mode that drops the redundant collapsible-card chrome, inside
 * a lightweight modal that never leaves the Settings page.
 */
import React from 'react';
import { X } from 'lucide-react';
import { PersonalMcpPanel } from '../../pages/MCPServersPage.jsx';

const T = {
  surface: 'var(--lyra-color-surface)',
  border: 'var(--lyra-color-border)',
  ink: 'var(--lyra-color-text)',
  ink3: 'var(--lyra-color-text-muted)',
};

export default function LyraApiKeyModal({ onClose }: { onClose: () => void }) {
  return (
    <>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 200, background: 'rgba(0,0,0,0.25)' }} />
      <div style={{
        position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%,-50%)',
        zIndex: 201, width: 560, maxWidth: 'calc(100vw - 32px)', maxHeight: '85vh',
        display: 'flex', flexDirection: 'column',
        background: T.surface, borderRadius: 16, border: `1px solid ${T.border}`,
        boxShadow: '0 20px 60px rgba(0,0,0,0.15)', overflow: 'hidden',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: `1px solid ${T.border}`, flexShrink: 0 }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: T.ink }}>Lyra API Key</div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: T.ink3, display: 'flex', padding: 4 }}>
            <X size={16} />
          </button>
        </div>
        <div style={{ padding: '18px 20px', overflowY: 'auto' }}>
          <PersonalMcpPanel embedded />
        </div>
      </div>
    </>
  );
}
